import React, {useId} from 'react';
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Typography} from "@mui/material";
import {PaymentType} from "../../../../constants/securspace-constants";
import {styled} from "@mui/material/styles";

import type {PaymentMethod} from "../../../../../types/PaymentMethod";

const PaymentOption = styled(FormControlLabel)(({theme}) => ({
  backgroundColor: theme.palette.grey[50],
  borderRadius: '0.57rem',
  paddingLeft: '0.1em',
  paddingRight: '0.3em',
  marginBottom: '0.2em',
  marginLeft: 0,
  marginRight: 0,
  width: '100%',
}));

const PaymentMethodOption = (props: { paymentMethod: PaymentMethod }) => {
  const {paymentMethod} = props;
  const hasNickName = !!paymentMethod.nickName && paymentMethod.nickName.trim() !== '';

  return (
    <PaymentOption
      value={paymentMethod.id}
      label={
        <>
          {hasNickName ? `${paymentMethod.nickName}: ` : null}
          <span style={{fontStyle: 'italic'}}>{paymentMethod.type === PaymentType.CARD ? paymentMethod.cardBrand : paymentMethod.bankName}</span>{` ending in ${paymentMethod.lastFour}`}
        </>
      }
      control={<Radio />}
    />
  );
};

interface PaymentMethodSelectProps {
  paymentMethods: PaymentMethod[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | null;
  label?: string;
  id?: string;
  emptyMessage?: string;
}

const PaymentMethodSelect = (props: PaymentMethodSelectProps) => {
  const {paymentMethods, onChange, value, label, id, emptyMessage = 'No payment methods available.'} = props;
  const generatedId = useId();
  const resolvedId = id ?? generatedId;

  return <FormControl component="fieldset" fullWidth>
    {label && <FormLabel component="legend" id={resolvedId} sx={{mb: 1, color: 'text.primary', typography: 'subtitle1'}}>{label}</FormLabel>}
      {paymentMethods.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{py: 1}}>
          {emptyMessage}
        </Typography>
      ) : (
        <RadioGroup
          aria-labelledby={resolvedId}
          name={"paymentMethod"}
          onChange={onChange}
          value={value ?? ''}
        >
          {paymentMethods.map((paymentMethod: PaymentMethod) => (
            <PaymentMethodOption
              key={paymentMethod.id}
              paymentMethod={paymentMethod}
            />
          ))}
        </RadioGroup>
      )}
    </FormControl>;
};

export default PaymentMethodSelect;
